import React, { useEffect, useRef, useState } from 'react';
import styles from './QuickAddOverlay.module.css';
import NobiEventTracker from "../../utils/NobiEventTracker";
import Events from "../../utils/Events";

const QuickAddOverlay = ({ variants, conversationId, merchantId, entryPoint }) => {
    const containerRef = useRef(null);
    const [isMultiRow, setIsMultiRow] = useState(false);
    const [sizesAddedToCart, setSizesAddedToCart] = useState([]);

    const isTestMode = process.env.NODE_ENV === 'test' || window.location.href.indexOf("localhost") > -1;

    useEffect(() => {
        const container = containerRef.current;
        if (container && container.children.length > 0) {
            const firstRowTop = container.children[0].offsetTop;
            const multiRowExists = Array.from(container.children).some(child => child.offsetTop > firstRowTop);
            setIsMultiRow(multiRowExists);
        }
    }, [variants]);

    if (!variants || variants.length === 0) {
        return null;
    }

    const handleClick = (e, variant) => {
        e.preventDefault();
        e.stopPropagation();

        if (isTestMode && window.location.href.indexOf("localhost:10094") > -1) {
            // Simulate adding to cart
            console.log("Simulating adding to cart for size " + variant.size);
            setSizesAddedToCart(prev => [...prev, variant.size]);
            return;
        }

        if (window.Shopify?.routes?.root) {
            let postBody = {
                items: [{
                    id: variant.internalId,
                    quantity: 1,
                }]
            };

            let eventData = {
                conversationId: conversationId,
                size: variant.size
            };
            NobiEventTracker.trackEvent(merchantId, entryPoint, Events.QuickAddProduct, false, true, eventData);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postBody)
            })
                .then(response => {
                    if (response.ok) {
                        setSizesAddedToCart(prev => [...prev, variant.size]);
                        console.log("Item added to cart");
                        return;
                    }
                    else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .catch(error => console.error('Error:', error));
        }
        else {
            console.log('Clicked quick add for size ' + variant.size + ' but Shopify is not available');
        }
    };

    return (
        <div className={styles.quickAddOverlay}>
            <div className={styles.content}>
                <h4>- Quick Add To Cart -</h4>
                <div
                    ref={containerRef}
                    className={`${styles.variantButtons} ${isMultiRow ? styles.multiRow : styles.singleRow}`}
                >
                    {variants.map((variant) => (
                        <button
                            key={variant.internalId}
                            className={`${styles.quickAddOption} ${sizesAddedToCart.includes(variant.size) ? styles.added : ''}`}
                            onClick={(e) => handleClick(e, variant)}
                        >
                            {variant.size || variant.name}
                            {sizesAddedToCart.includes(variant.size) && (
                                <svg className={styles.checkmark} viewBox="0 0 52 52">
                                    <path className={styles.checkmarkPath} d="M14 27 l7 7 l16 -16" />
                                </svg>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default QuickAddOverlay;
